import { render, staticRenderFns } from "./AnalysisTrend.vue?vue&type=template&id=36a157b7&scoped=true"
import script from "./AnalysisTrend.vue?vue&type=script&lang=js"
export * from "./AnalysisTrend.vue?vue&type=script&lang=js"
import style0 from "./AnalysisTrend.vue?vue&type=style&index=0&id=36a157b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a157b7",
  null
  
)

export default component.exports